// extracted by mini-css-extract-plugin
export default {"menu":"DropdownMenu_menu__-NGvj","menuLink":"DropdownMenu_menuLink__+7U5B","menu-label":"DropdownMenu_menu-label__c1Ahr","paper":"DropdownMenu_paper__MrXvD"};